export default "__VITE_ASSET__B2tofeOd__"